import React, { useCallback } from 'react';
import { combineClasses } from '../../../utils/formatters';
import { TOPBAR_CONFIG, TOPBAR_RESPONSIVE } from '../../../config/topbarConfig';

// Logo Component - Memoized for performance with enhanced accessibility
export const TopBarLogo = React.memo(({ 
  brandName, 
  onLogoClick, 
  showLogo 
}) => {
  const handleClick = useCallback(() => {
    if (onLogoClick) {
      onLogoClick();
    }
  }, [onLogoClick]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  }, [handleClick]);

  if (!showLogo) return null;

  const isInteractive = Boolean(onLogoClick);

  return (
    <div className={TOPBAR_CONFIG.COMPONENTS.layout.logoContainer}>
      <button 
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        className={combineClasses(
          TOPBAR_CONFIG.COMPONENTS.layout.logoButton,
          TOPBAR_RESPONSIVE.BREAKPOINTS.SPACING.logo,
          isInteractive ? combineClasses(
            TOPBAR_CONFIG.COMPONENTS.misc.cursorPointer, 
            TOPBAR_CONFIG.HOVER_EFFECTS.logo
          ) : TOPBAR_CONFIG.COMPONENTS.misc.cursorDefault
        )}
        aria-label={isInteractive ? `${brandName} - Go to homepage` : brandName}
        disabled={!isInteractive}
        tabIndex={isInteractive ? 0 : -1}
      >
        <div className={TOPBAR_CONFIG.COMPONENTS.layout.logoIconContainer}>
          <img
            src={TOPBAR_CONFIG.BRAND.logoImage}
            alt={`${brandName} logo`}
            className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
          />
        </div>
        <span className={combineClasses(
          TOPBAR_CONFIG.COMPONENTS.typography.fontBold,
          TOPBAR_CONFIG.BRAND.brandSize.mobile,
          TOPBAR_CONFIG.BRAND.brandSize.desktop,
          TOPBAR_CONFIG.BRAND.hideOnMobile,
          TOPBAR_CONFIG.BRAND.color,
          'max-w-[120px] sm:max-w-none truncate'
        )}>
          {brandName}
        </span>
      </button>
    </div>
  );
});

TopBarLogo.displayName = 'TopBarLogo';

// Spacer Component - Memoized for performance
export const TopBarSpacer = React.memo(() => (
  <div className={TOPBAR_CONFIG.COMPONENTS.layout.spacer}></div>
));

TopBarSpacer.displayName = 'TopBarSpacer';
